import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api/api';
import '../styles/login.css';
import loginPattern from '../assets/login.png';
import { setAuthSession } from '../utils/authStorage';
 
export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
 
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password) {
      setError('Email and password are required.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await API.post('/auth/login', { email: email.trim().toLowerCase(), password });
      setAuthSession(data.user, data.token);
      if (data.user.role === 'superadmin') {
        navigate('/superadmin');
      } else if (['recruiter', 'junior_recruiter', 'senior_recruiter', 'hr', 'admin'].includes(data.user.role)) {
        navigate('/recruiter');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div className="login-page" style={{ backgroundImage: `url(${loginPattern})` }}>
      {/* Left: login pattern image */}
      <div className="login-left" />
 
      {/* Right: login card */}
      <div className="login-right">
        <div className="login-card">
 
          <div className="card-logo">
            <img src="/logos/inteliment-logo.svg" alt="Inteliment" />
          </div>
 
          <h1 className="login-title">Login</h1>
          <p className="login-subtitle">TO YOUR ACCOUNT</p>
 
          <form onSubmit={handleLogin} noValidate>
 
            <div className="form-group">
              <label className="form-label" htmlFor="email">Email address<span className="required-star">*</span></label>
              <input
                type="email"
                id="email"
                className={`form-input${error ? ' err' : ''}`}
                placeholder="example@gmail.com"
                value={email}
                onChange={e => { setEmail(e.target.value); setError(''); }}
                autoComplete="email"
              />
            </div>
 
            <div className="form-group">
              <label className="form-label" htmlFor="password">Password<span className="required-star">*</span></label>
              <div className="pw-wrap">
                <input
                  type={showPw ? 'text' : 'password'}
                  id="password"
                  className={`form-input${error ? ' err' : ''}`}
                  placeholder="••••••••••"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(''); }}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="toggle-pw"
                  onClick={() => setShowPw(!showPw)}
                  aria-label="Toggle password visibility"
                >
                  {showPw ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>
 
            <button type="submit" className="btn-signin" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
 
            <p className="login-note">Use the credentials provided by your Recruiter team.</p>
 
            {error && (
              <div className="err-msg show">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </div>
            )}
 
          </form>
        </div>
      </div>
    </div>
  );
}
 
 